export interface IndiaStateDefinition {
  name: string;
  code: string;
  zone: 'North' | 'South' | 'East' | 'West' | 'Central' | 'North-East' | 'Union Territory';
  x: number;
  y: number;
}

export const INDIA_STATES: IndiaStateDefinition[] = [
  { name: 'Jammu and Kashmir', code: 'JK', zone: 'North', x: 43, y: 10 },
  { name: 'Ladakh', code: 'LA', zone: 'North', x: 57, y: 8 },
  { name: 'Himachal Pradesh', code: 'HP', zone: 'North', x: 45, y: 20 },
  { name: 'Punjab', code: 'PB', zone: 'North', x: 35, y: 24 },
  { name: 'Chandigarh', code: 'CH', zone: 'Union Territory', x: 40, y: 28 },
  { name: 'Uttarakhand', code: 'UK', zone: 'North', x: 50, y: 24 },
  { name: 'Haryana', code: 'HR', zone: 'North', x: 37, y: 31 },
  { name: 'Delhi', code: 'DL', zone: 'Union Territory', x: 42, y: 34 },
  { name: 'Rajasthan', code: 'RJ', zone: 'West', x: 28, y: 39 },
  { name: 'Uttar Pradesh', code: 'UP', zone: 'North', x: 53, y: 35 },
  { name: 'Bihar', code: 'BR', zone: 'East', x: 67, y: 40 },
  { name: 'Sikkim', code: 'SK', zone: 'North-East', x: 78, y: 33 },
  { name: 'Arunachal Pradesh', code: 'AR', zone: 'North-East', x: 92, y: 28 },
  { name: 'Assam', code: 'AS', zone: 'North-East', x: 84, y: 38 },
  { name: 'Nagaland', code: 'NL', zone: 'North-East', x: 92, y: 38 },
  { name: 'Manipur', code: 'MN', zone: 'North-East', x: 91, y: 45 },
  { name: 'Mizoram', code: 'MZ', zone: 'North-East', x: 88, y: 52 },
  { name: 'Tripura', code: 'TR', zone: 'North-East', x: 83, y: 50 },
  { name: 'Meghalaya', code: 'ML', zone: 'North-East', x: 79, y: 44 },
  { name: 'West Bengal', code: 'WB', zone: 'East', x: 74, y: 48 },
  { name: 'Jharkhand', code: 'JH', zone: 'East', x: 66, y: 48 },
  { name: 'Odisha', code: 'OD', zone: 'East', x: 67, y: 58 },
  { name: 'Chhattisgarh', code: 'CG', zone: 'Central', x: 56, y: 56 },
  { name: 'Madhya Pradesh', code: 'MP', zone: 'Central', x: 47, y: 49 },
  { name: 'Gujarat', code: 'GJ', zone: 'West', x: 22, y: 52 },
  { name: 'Dadra and Nagar Haveli and Daman and Diu', code: 'DN', zone: 'Union Territory', x: 20, y: 59 },
  { name: 'Maharashtra', code: 'MH', zone: 'West', x: 34, y: 62 },
  { name: 'Goa', code: 'GA', zone: 'West', x: 29, y: 71 },
  { name: 'Telangana', code: 'TS', zone: 'South', x: 46, y: 70 },
  { name: 'Andhra Pradesh', code: 'AP', zone: 'South', x: 53, y: 79 },
  { name: 'Karnataka', code: 'KA', zone: 'South', x: 36, y: 78 },
  { name: 'Tamil Nadu', code: 'TN', zone: 'South', x: 45, y: 92 },
  { name: 'Kerala', code: 'KL', zone: 'South', x: 33, y: 90 },
  { name: 'Puducherry', code: 'PY', zone: 'Union Territory', x: 50, y: 92 },
  { name: 'Andaman and Nicobar Islands', code: 'AN', zone: 'Union Territory', x: 76, y: 92 },
  { name: 'Lakshadweep', code: 'LD', zone: 'Union Territory', x: 20, y: 90 }
];
